import React from 'react'
import { useTranslation } from 'react-i18next'
import UseCaseListWrapper from '../UseCases/UseCaseListWrapper'

const HomePageUseCases = () => {
  const { t } = useTranslation()

  return (
    <UseCaseListWrapper>
      <h1>{t('homePage.useCases.title')}</h1>
    </UseCaseListWrapper>
  )
}

export default HomePageUseCases
